import { getBuyerId } from 'dibs-cookie-jar';
import serverVars from 'server-vars';

import { sendAnalyticsData } from './perfAnalyticsHelpers.ts';
import { getForwardedHost } from './helpers.ts';

export const trackClientError = ({
    rumTransactionName,
    monitoringGroupName,
    errorMessage,
    errorName,
    errorStack,
}: {
    rumTransactionName: string;
    monitoringGroupName: string;
    errorMessage: string;
    errorName: string;
    errorStack: string;
}): void => {
    /**
     * Prevent local devboxes from sending client errors to the server.
     */
    if (process.env.NODE_ENV !== 'production') {
        return;
    }
    const payload = {
        rumTransactionName,
        monitoringGroupName,
        forwardedHost: getForwardedHost(),
        clientUrl: location.href,
        clientUserId: getBuyerId(document.cookie) || undefined,
        errorMessage,
        errorName,
        errorStack,
        appVersion: serverVars.get('appVersion') || `0.0.0`,
        deviceType: serverVars.get('settings.deviceType'),
    };

    sendAnalyticsData(
        `${location.protocol}//${location.host}/soa/client-analytics/error/`,
        payload
    );
};
